import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioFacturacionOtroService {

  constructor(private requestUrl: ReportesRequestService) {}

  public async getFacturacionOtro( codigoBaseDatos: string, params: ObjectRequestFacturacion ) {
    try {
      const response = await this.requestUrl.getRequest(
        'reporte-facturacion-otro/data',
        [
          codigoBaseDatos,
          {
            ln_unco_trnsccn: params.uncoTracnsaccion,
            lc_tpo_dcmnto: params.tipoDocumento,
            ll_mstrr_dtlle_srvcs: params.detalleServicio,
            ll_mstrr_dtlle_cero: params.detalleCero,
            ln_idntfca_cmpnnte: 3
          }
        ]
      );
      return response;

    } catch (e) {
      alert(e);
    }
    return null;
  }

  public async getFacturacionOtroData( codigoBaseDatos: string, params: ObjectRequestFacturacion, uncoLogin: string ) {
    try {
      const response = await this.requestUrl.getRequest(
        'reporte-facturacion-otro/info',
        [
          codigoBaseDatos,
          {
            ln_unco_trnsccn: params.uncoTracnsaccion,
            lc_tpo_dcmnto: params.tipoDocumento,
            ln_unco_lgn: uncoLogin,
            lb_mstrr_cdgo_brrs: 1
          }
        ]
      );
      return response;

    } catch (e) {
      alert(e);
    }
    return null;
  }

  public async getFacturacionFormaPago( codigoBaseDatos: string, params: ObjectRequestFacturacion ) {
    try {
      const response = await this.requestUrl.getRequest(
        'reporte-facturacion-otro/forma-pago',
        [
          codigoBaseDatos,
          {
            ln_unco_trnsccn: params.uncoTracnsaccion,
            lc_tpo_dcmnto: params.tipoDocumento,
            ln_idntfca_cmpnnte: 3,
            ll_mstrr_dtlle_srvcs: params.detalleServicio
          }
        ]
      );
      return response;

    } catch (e) {
      alert(e);
    }
    return null;
  }

}

export interface ObjectRequestFacturacion {
  uncoTracnsaccion: string;
  tipoDocumento: string;
  detalleServicio: string;
  detalleCero: string;
}

export interface FacturacionOtroEntity {
  codigoProcedimiento: string;
  cantidad: string;
  descripcionProcedimiento: string;
  valorUnitario: string;
  valorPorcentaje: string;
  descripcionPuntoAtencion: string;
  uncoSedePuntoAtencion: string;
  activaEncabezado: string;
  unco: string;
  nivel: string;
  fechaOrden: string;
}
